// docs: https://github.com/altostra/type-validations#readme
import { anyOf, isEmptyObject, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isCustomObjectsUsageResult = anyOf(
  objectOf({
    record_count: number,
    record_limit: number,
  }),
  isEmptyObject
);
